import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

interface Params {
    template: CriterionTemplate;
}

export function getFlagDisabledReferenceValueSchema({ template }: Params) {
    const conditionalRefs = template.displayMetadata.conditionalValueReference;

    if (!conditionalRefs) {
        return null;
    }

    return template.evaluator.references[conditionalRefs.flagDisabledReference]?.schema;
}
